import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Role } from '../../../models/enums';
import { AuthService } from '../../auth/auth.service';

export const externalModuleAccessGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean | UrlTree => {

  const authService = inject(AuthService);
  const router = inject(Router);
  const moduleAccess: Role | null = route.data['moduleExternalAccess'] ?? null;

  if (!authService.profile) {
    const queryParams = state.url && state.url !== '/' ? { returnUrl: state.url } : undefined;
    return router.createUrlTree(['/sign-in'], queryParams ? { queryParams } : undefined);
  }

  if(authService.profile['external'] === undefined) {
    authService.profile['external'] = false;
  }

  if (authService.profile.external === false) {
    return true;
  }

  // Si le compte externe a le role d'accès au module on le laisse passer

  if (authService.profile['roles_externals'] && authService.profile.roles_externals.some((role: { role: { identifier: string } }) => role.role.identifier === moduleAccess)) {
    return true;
  }

  return router.navigate(['/access-denied']);



};
